import * as React from 'react';
import {Switch} from 'react-router-dom';

import type {User} from 'nutshell-core/users/users-types';

import {PromptedRoute} from '../../util/prompted-route';

import {PageWrapper} from '../layout/page-wrapper';
import {MarketingSidebar} from '../marketing/marketing-sidebar';
import {DomainsPageStandalone} from '../setup/domains/domains-page-standalone';

import {DEFAULT_EMAIL_MARKETING_REDIRECT_PATH} from './email-marketing-root';
import {EmailMarketingRoutes, getPageContainerHeader} from './routes';
import {EmailMarketingRedirectRoutes} from './routes/email-marketing-redirect-routes';
import {shouldHideMarketingSidebar} from './routes/helpers';
import {RestrictedRoute} from './routes/restricted-route';
import {SmsMarketingRoutes} from './routes/shared-routes';

type Props = {
    user: User;
};

export function EmailMarketingRootEmbedded(props: Props) {
    const hasFullAccessToCampaigns = props.user.permissions.canAccessFullCampaigns;
    const shouldHideSidebar = shouldHideMarketingSidebar(window.location.pathname);
    const canAccessSetup = props.user.permissions.canAccessSetup;

    return (
        <PageWrapper
            header={getPageContainerHeader(window.location.pathname)}
            sidebar={
                shouldHideSidebar ? null : <MarketingSidebar user={props.user} isEmbedded={true} />
            }
            isEmbedded={true}
        >
            <EmailMarketingRedirectRoutes />
            <Switch>
                <RestrictedRoute
                    path='/email-marketing/landing-pages/domains'
                    exact={true}
                    hasAccess={true}
                    redirectPath='/email-marketing/landing-pages'
                    render={() => {
                        return <DomainsPageStandalone />;
                    }}
                />
                <RestrictedRoute
                    path='/marketing/landing-pages/domains'
                    exact={true}
                    hasAccess={true}
                    redirectPath='/marketing/landing-pages'
                    render={() => {
                        return <DomainsPageStandalone />;
                    }}
                />
            </Switch>
            <EmailMarketingRoutes
                hasFullAccessToCampaigns={hasFullAccessToCampaigns}
                canAccessSetup={canAccessSetup}
            />
            <SmsMarketingRoutes
                hasFullAccessToCampaigns={hasFullAccessToCampaigns}
                canAccessSetup={canAccessSetup}
                redirectPath={DEFAULT_EMAIL_MARKETING_REDIRECT_PATH}
            />
            <PromptedRoute
                routeListType='allow'
                // allow list of top-level route paths
                routePaths={[
                    '/email-marketing/summary',
                    '/email-marketing/newsletters',
                    '/email-marketing/broadcasts',
                    '/email-marketing/drip-sequences',
                    '/email-marketing/audiences',
                    '/email-marketing/templates',
                    '/email-marketing/sender-address',
                    '/email-marketing/landing-pages',
                    '/email-marketing/domains',
                    '/marketing/email/broadcasts',
                    '/marketing/email/newsletters',
                    '/marketing/email/audiences',
                    '/marketing/email/templates',
                    '/marketing/email/drip-sequences',
                    '/marketing/sender-address',
                    '/marketing/landing-pages',
                    '/marketing/domains',
                    '/marketing/audiences',
                    '/marketing/preference-center',
                    '/marketing/sms',
                ]}
            />
        </PageWrapper>
    );
}
